import React from 'react';

import windoesData from '../../assets/data/pages/windows.json';

export default () => {
  const [data, setData] = React.useState({});
  React.useEffect(() => {
    setData(windoesData.tens);
  }, []);
  return (
    <div className='mt-5 mb-5'>
      <div className='thaaa-glow-all thaaa-glow-tens'>
        <section className='container'>
          <div className='content-width tens-back'>
            <div className='columns'>
              <div className='column is-8'>
                <h1 className='has-text-white mt-15 title'>{ data.title }</h1>
                <p className='has-text-white is-size-5'>{ data.content }</p>
              </div>
              <div className='column'></div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}
